import { psAxios } from '@patsnap/common-ps-http';

import { initCookie } from './init-cookie';

export * from './init-cookie';

export enum TrackEventType {
    IpNavClick = 'SS IP NAV CLICK',
    IpNavUpgradeClick = 'SS IP NAV UPGRADE CLICK',
    PlgPageView = 'SS PLG PAGE VIEW',
    EurekaUpgradePage = 'SS Eureka Upgrade Page',
    IpDrafting = 'SS IP DRAFTING',
    PlgRegister = 'ss_plg_register',
    IpDisclosure = 'ss_ip_disclosure',
    IpPatentDraft = 'ss_ip_patent_draft',
    IpProsecution = 'ss_ip_prosecution',
}

export enum TrackSourceType {
    IpNav = 'ip-nav',
    IpNavUpgrade = 'ip-nav-upgrade',
    AgentHome = 'agent_home',
    UpgradeTrigger = 'upgrade_trigger',
    PricingPageView = 'pricing_page_view',
    ClickSubscribePro = 'click_subscribe_pro',
    ClickSubscribeMax = 'click_subscribe_max',
    CreateTask = 'create_task',
    DocOutputConfirm = 'doc_output_confirm',
    ExportAgentDoc = 'export_agent_doc',
    ShareAgent = 'share_agent',
    RegisterExposure = 'register_exposure',
    RegisterClick = 'register_click',
    RegisterClose = 'register_close',
}

export interface TrackEvent {
    source_type?: TrackSourceType;
    other_param?: string;
    event_detail_str?: string;
    module_type?: string;
    event_type?: TrackEventType;
}

export function track(data: TrackEvent): Promise<any> {
    const defaultData = {
        module_type: 'EUREKA',
    };

    let eventDetail: Record<string, unknown> = {};
    if (data.event_detail_str) {
        try {
            eventDetail = JSON.parse(data.event_detail_str);
        } catch {
            // 解析失败保留原值不处理
        }
    }
    const event_detail_str = JSON.stringify({
        app_name: 'drafting',
        signatureId: initCookie.getVisitorId(),
        campaignName: initCookie.getCampaignName(),
        ...eventDetail,
    });

    return psAxios.post(
        `${import.meta.env.VITE_EUREKA_SERVICE_URI}/eureka/tracking/add`,
        {
            ...defaultData,
            ...data,
            event_detail_str,
        },
        {
            headers: {
                'X-API-VERSION': '1.0',
            },
        },
    ).catch((e) => {
        console.warn('trackApi error: ', e);
    });
};
